// Custo Novas Vendas (Gestão Orçamentária): DRE Gerencial de custo projetado por
// categoria de despesa associada às novas vendas do ano — mesma visão executiva
// de Faturamento Bruto / Novas Vendas.
// Espelha backend/config.py ROLES_CUSTO_NOVAS_VENDAS_ORCAMENTARIA — mantenha em sincronia.
export const ROLES_CUSTO_NOVAS_VENDAS_ORCAMENTARIA = ["admin", "EXECUTIVA", "GESTOR_ESTRATEGICO"];

// Ordem fixa das 6 categorias do DRE Gerencial.
// Espelha backend/services/custo_novas_vendas_svc.py CATEGORIAS_CUSTO_NOVAS_VENDAS —
// mantenha em sincronia.
export const CATEGORIAS_CUSTO_NOVAS_VENDAS = [
  { codigo: "2", label: "Salários e Encargos" },
  { codigo: "2.3", label: "Serviços Terceirizados" },
  { codigo: "2.4", label: "Marketing e Publicidade" },
  { codigo: "2.5", label: "Viagens" },
  { codigo: "2.6", label: "Administrativas Gerais" },
  { codigo: "2.7", label: "Equipamentos e Materiais" },
];
